export default __webpack_public_path__ + "static/benefitImg-b4a5df03885abd49cb30bb4f52e9e3b5.png";